jQuery(function ($) {

  $(".banner-carousel").each(function () {
    $(this).slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      rows: 0,
      dots: true,
      // autoplay: true,
      autoplaySpeed: 4000,
      appendDots: $(this).closest('.banner').find('.banner-dots'),
      customPaging: function (slider, i) {
        return $('<button>').html($('<span>').addClass('sr-only').text(i + 1))
      },
      fade: true,
      cssEase: 'linear',
      arrows: false,
    });
  });

});